// extracted by mini-css-extract-plugin
export default {"placeholder":"PlaceholderImage_placeholder__WlQ6d","svg":"PlaceholderImage_svg__M52BO"};